import type { ReactNode } from "react";
import { cn } from "@/utils/common.utils";

interface PageHeaderProps {
  title?: ReactNode;
  description?: ReactNode;
  eyebrow?: ReactNode;
  actions?: ReactNode;
  className?: string;
  actionsClassName?: string;
}

export default function PageHeader({ title, description, eyebrow, actions, className, actionsClassName }: PageHeaderProps) {
  return (
    <header className={cn("flex flex-col gap-5 sm:flex-row sm:items-start sm:justify-between", className)}>
      <div className="min-w-0">
        {eyebrow && <div className="mb-1 text-xs font-semibold uppercase tracking-[0.15em] text-dash-faint">{eyebrow}</div>}
        <h1 className="text-3xl font-bold tracking-tight text-dash-ink">{title}</h1>
        {description && <p className="mt-1 text-sm text-dash-muted">{description}</p>}
      </div>
      {actions && (
        <div
          className={cn(
            "flex w-full shrink-0 flex-col items-stretch gap-2 [&>*]:w-full sm:w-auto sm:flex-row sm:flex-wrap sm:items-center sm:[&>*]:w-auto",
            actionsClassName
          )}
        >
          {actions}
        </div>
      )}
    </header>
  );
}
